import React from 'react';
import { Modal } from 'antd';
import componentStyle from './index.scss';
import { getRoleOfLoggedInUser } from '../../../tm/investigationDetail/InvestDetailHeader/investDetailHeaderUtil';
import { isResourceAvailable } from '../../../../util';
import { getSelectedResources } from '../../../../util/resourceManager';

const { trmResources } = getSelectedResources();

/**
 * Promote
 */

export class PromoteComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSuperVisor: false,
      isModalVisible: false,
      promoteAccess: false
    };
  }

  componentDidMount() {
    let PROMOTE_ACTION_ACCESS = isResourceAvailable(
      { data: this.props.authentication },
      trmResources.APP_3_RESOURCE_UI_AMLS_CHAMPION_UPDATE
    );
    this.setState({
      promoteAccess: PROMOTE_ACTION_ACCESS
    });

    const { isSuperVisor } = getRoleOfLoggedInUser(this.props.authentication);
    this.setState({ isSuperVisor });
  }

  toggleModal = () => {
    this.setState({
      isModalVisible: !this.state.isModalVisible
    });
  };

  handleOk = () => {
    const { champion, onAction } = this.props;
    const { challengerId } = champion || {};

    if (onAction && champion && challengerId) {
      onAction(challengerId);
    }
    this.toggleModal();
  };

  handleCancel = () => {
    this.toggleModal();
  };

  render() {
    const { isModalVisible } = this.state;

    return (
      <div className={componentStyle.displayFlexJustifyAndAlignCenter}>
        <Modal
          title={'Promote Challenger'}
          destroyOnClose={true}
          maskClosable={false}
          visible={isModalVisible}
          okText={'Confirm'}
          onOk={this.handleOk}
          onCancel={this.handleCancel}>
          <div>
            <div>Promote the Challenger?</div>
          </div>
        </Modal>
        <div
          className={
            this.state.promoteAccess
              ? componentStyle.revertBtn
              : componentStyle.revertBtnDisabled
          }
          onClick={this.state.promoteAccess ? this.toggleModal : undefined}>
          Promote
        </div>
      </div>
    );
  }
}
